/* eslint-disable */
import { Button, CircularProgress, Grid, Link, Typography, IconButton, Snackbar, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IntegrationService } from '../../../../services/integration.service';
import mcpLogo from './logo.png';
import { FileCopy } from '@material-ui/icons';
export interface McpConnectorResponse {
  connected: boolean;
  error?: string;
  url?: string;
  nextState?: 'start' | 'error' | 'connected';
}
export default function McpConnector(props: { afterDisconnect?: () => void }) {
  const location = useLocation();

  const [state, setState] = useState<'start' | 'error' | 'connected'>('start');
  const [errorDescription, setErrorDescription] = useState<string>('');
  const [waiting, setWaiting] = useState(false);
  const [mcpUrl, setMcpUrl] = useState<string>('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const connect = () => {
    setWaiting(true);
    IntegrationService.connect('mcp', {})
      .then((response) => {
        if (response.connected) {
          setState('connected');
          setMcpUrl(response.mcpUrl);
        } else {
          setState('start');
        }
      })
      .catch((error) => {
        console.log(error);

        setErrorDescription(error.response?.data?.data?.message ?? error.message);
        setState('error');
      })
      .finally(() => {
        setWaiting(false);
      });
  };
  const disconnect = () => {
    setWaiting(true);
    IntegrationService.disconnect('mcp').finally(() => {
      setState('start');
      setWaiting(false);
      if (props.afterDisconnect) {
        props.afterDisconnect();
      }
    });
  };
  const getStatus = () => {
    setWaiting(true);
    IntegrationService.getInfo('mcp')
      .then((response) => {
        if (response.connected) {
          setState('connected');
          setMcpUrl(response.mcpUrl);
        } else {
          setState('start');
        }
      })
      .catch((error) => {
        console.log(error);

        setErrorDescription(error.response?.data?.data?.message ?? error.message);
        setState('error');
      })
      .finally(() => {
        setWaiting(false);
      });
  };

  useEffect(() => {
    getStatus();
  }, [location]);

  const handleCopy = () => {
    navigator.clipboard.writeText(mcpUrl).then(() => {
      setSnackbarOpen(true);
    });
  };
  return (
    <Grid container p={2}>
      <img src={mcpLogo} alt="MCP" style={{ height: 40, marginBottom: 5, marginTop: 5 }} />
      {waiting ? (
        <Grid container mt={2}>
          <CircularProgress />
        </Grid>
      ) : (
        <>
          {state == 'start' && (
            <>
              <Grid container m={2}>
                <Typography variant="body1">
                  Enable MCP access to allow AI clients such as ChatGPT, Claude, and Gemini to integrate with the
                  Curbinity system.
                </Typography>
              </Grid>
              <Grid container>
                <Button variant="contained" color="primary" onClick={() => connect()}>
                  Enable MCP Access
                </Button>
              </Grid>
            </>
          )}
          {state == 'error' && (
            <>
              <Grid container mt={2}>
                <Typography variant="subtitle1" color="red">
                  Error
                </Typography>
              </Grid>
              <Grid container>
                <Typography variant="body1" color="red">
                  {errorDescription}
                </Typography>
              </Grid>
              <Grid container mt={2}>
                <Button variant="contained" color="primary" onClick={() => getStatus()}>
                  Try Again
                </Button>
              </Grid>
            </>
          )}
          {state == 'connected' && (
            <>
              <Grid container mt={2} mb={2}>
                <Typography variant="subtitle1" color="green">
                  MCP access enabled.
                </Typography>
              </Grid>
              <Grid container mb={2} direction="column">
                <Typography variant="body2" gutterBottom>
                  Use the following MCP SSE URL to connect your AI client (e.g., ChatGPT, Claude Desktop, Gemini):
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Grid
                    container
                    sx={{
                      p: 1.5,
                      bgcolor: 'action.hover',
                      borderRadius: 1,
                      fontFamily: 'monospace',
                      wordBreak: 'break-all',
                      border: '1px solid',
                      borderColor: 'divider',
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        p: 1.5,
                        fontFamily: 'monospace',
                        wordBreak: 'break-all',
                        flexGrow: 1,
                      }}
                    >
                      {mcpUrl}
                    </Typography>
                    <Button onClick={handleCopy} color="primary" size="small">
                      Copy
                    </Button>
                  </Grid>
                </Box>
              </Grid>
              <Grid container mb={3}>
                <Typography variant="caption" color="textSecondary">
                  Ensure your client is configured to handle Server-Sent Events (SSE) for MCP communication.
                </Typography>
              </Grid>
              <Grid container>
                <Button variant="contained" color="error" onClick={disconnect}>
                  Disable
                </Button>
              </Grid>
            </>
          )}
        </>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="URL copied to clipboard!"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Grid>
  );
}
